import React from 'react'
import { Button, Modal, Spacer, View } from 'oio-react'
import { Redirect, Route, Switch, useRouteMatch, useParams } from 'react-router-dom'
import { PencilIcon, VisibilityIcon } from 'assets/icons'
import { adminUrl, pageUrl } from 'config/constants/urls'
import ProtoHeadingBlock from 'src/components/Settings/ProtoHeadingBlock'
import ProtoReturnBar from 'src/components/Settings/ProtoReturnBar'
import ModalRoute from 'src/components/utils/ModalRoute'
import { usePage } from 'src/graphql/hooks'
import About from './About'
import VisualEditor from './VisualEditor'

const CustomPageSettings = () => {
   const { pageId } = useParams()
   const match = useRouteMatch()
   const { page, loading: pageIsLoading } = usePage({ id: pageId })

   if (pageIsLoading) {
      return null
   }

   return (
      <>
         <ProtoReturnBar
            display="block[a-c] none[d-f]"
            returnLinkName="Admin Workspace"
            returnLinkTo={adminUrl}
         />
         <View display="flex" justifyContent="center" width="100%">
            <View
               width="100%"
               maxWidth="100%[a-c] 650px[d-f]"
               padding="40px 20px">
               <View width="100%">
                  <View width="100%" display="flex">
                     <View flex="1 1 auto" paddingRight="30px">
                        <ProtoHeadingBlock
                           title={page.title}
                           description="Custom Page"
                        />
                     </View>
                     <View display="flex" flex="0 0 auto" paddingTop="10px">
                        <Button
                           linkTo={pageUrl(page)}
                           name="View Page"
                           color="#ddd"
                           textColor="#333"
                           size="md"
                           textSize="0.9"
                           padding="15px">
                           <View display="flex" alignItems="center" marginRight="5px">
                              <VisibilityIcon
                                 width="16px"
                                 height="16px"
                                 color="#333"
                                 strokeWidth="2px"
                              />
                           </View>
                        </Button>
                        <Spacer orientation="vertical" size="1" />
                        <Button
                           linkTo={`${match.url}/edit`}
                           name="Edit in Visual Editor"
                           color="#ddd"
                           textColor="#333"
                           size="md"
                           textSize="0.9"
                           padding="15px">
                           <View display="flex" alignItems="center" marginRight="5px">
                              <PencilIcon
                                 color="#333"
                                 width="12px"
                                 height="12px"
                                 strokeWidth="4px"
                              />
                           </View>
                        </Button>
                     </View>
                  </View>
                  <Spacer size="3" />
                  <Switch>
                     <Redirect exact from={match.path} to={`${match.path}/about`} />
                     <Route path={`${match.path}/about`} component={About} />
                     <ModalRoute path={`${match.path}/edit`}>
                        {({ open, onCloseComplete, onCloseTrigger }) => (
                           <Modal
                              borderRadius="0px"
                              width="100%"
                              height="100%"
                              onCloseComplete={onCloseComplete}
                              onCloseTrigger={onCloseTrigger}
                              open={open}>
                              {/* TODO: Update this
                              This uses a returlUrl instead of a the close trigger for now
                              as the VisualEditor is also used by Initiative Settings
                              See PR #692 */}
                              <VisualEditor returnUrl={match.url} />
                           </Modal>
                        )}
                     </ModalRoute>
                  </Switch>
               </View>
            </View>
         </View>
      </>
   )
}

export default CustomPageSettings
